import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
const task_method = {
    //切换定时任务
    clickScheduleBtn(direction,item,index) {
        if(item.schedules && !item.schedules.type){
            //未设置定时任务,则打开定时任务窗口
            direction.openFunctionPopup(7,item);
        }else {
            //执行修改定时任务
            this.changeSchedulesStatus(direction,item,index);
        }
    },
    //改变任务的设定时间状态
    changeSchedulesStatus(direction,itemData, index) {
        if (!itemData.updateFlag) {
            let item = Object.assign({}, itemData);
            var updateData;
            let schedules = Object.assign({}, item.schedules);
            let options = Object.assign({}, item.options);
            let disabled;
            let that = direction;
            let schType = commonUtils.substringType(schedules.type);
            itemData.updateFlag = true;
            let getData;
            let timeArr = [];
            for (let i = 0; i < schedules.times.length; i++) {
                if (schedules.times[i] && schedules.times[i] != '"null"') {
                    timeArr.push(schedules.times[i]);
                }
            }
            schedules.times = timeArr;
            schedules.type = schType;
            if (item.schedules.disabled == false || item.schedules.disabled == true) {
                disabled = !item.schedules.disabled;
            } else if (item.schedules.disabled == undefined) {
                disabled = true;
            }
            schedules.disabled = disabled;
            if (schedules.type == 'Monthly' || schedules.type == '=Monthly') {
                schedules.days = this.packageMonthDaysData(item);
            }
            if (schedules.type == 'Weekly' || schedules.type == '=Weekly') {
                schedules.weeks = this.packageWeekDaysData(item);
            }
            delete schedules.outDate;
            schedules.clientTime = commonUtils.getNowDateFormat();
            if (item.groupId) {
                updateData = new taskListUtils.updateGdData(item.groupId, commonUtils.getUser().id, item.type, item.name,
                options, schedules);
            } else {
                updateData = new taskListUtils.updateIdData(item.id, commonUtils.getUser().id, item.type, item.name,
                options, schedules);
            }
            item.schedules.disabled = disabled;
            console.log(that.tasklistData)
            if (itemData.branchType != 'businessTransfer') {
                console.log(itemData)
                that.Utils.doTasksRequest("update", updateData).then(result => {
                    if (result.status == 200) {
                        if (item.isMultiTask) {
                            getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, item.id);
                        } else {
                            getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
                        }
                        itemData.updateFlag = false;
                        that.Utils.doTasksRequest("get", getData).then(res => {
                            if (itemData.id == res.tasks[0].id) {
                                itemData.schedules = res.tasks[0].schedules;
                            }
                        });
                    } else {
                        item.schedules.disabled = !disabled;
                        itemData.updateFlag = false;
                        if (result.msg == "timepassed") {
                            that.$toast({
                                text: result.msg,
                                type: 'fail',
                                idValue: "rightBodyList"
                            });
                        } else {
                            that.$toast({
                                text: that.$t('language.exception.' + result.reason),
                                type: 'fail',
                                idValue: "rightBodyList"
                            });
                        }
                    }
                });
            } else {
                delete updateData.type;
                that.Utils.doBusinessTransferRequest("update", updateData).then(data => {
                itemData.updateFlag = false;
                that.$forceUpdate();
                if (disabled) {
                    clearTimeout(item.timeoutExeCute);
                    delete item.timeoutExeCute;
                } else {
                    //定时获取任务进度
                    that.getTimedExecution();
                }
                }).catch(err => {
                    item.schedules.disabled = !disabled;
                    itemData.updateFlag = false;
                    that.$forceUpdate();
                    if (err.reason) {
                        err = that.$t('language.exception.' + err.reason)
                    }
                    that.$toast({
                        text: err,
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                });
            }
        }
    },
    
    //封装按周的数据
    packageWeekDaysData(item) {
        var weekArr;
        let value = item.schedules;
        let weekDaysArr = new Array;
        if (!(value.weeks instanceof Array)) {
            weekArr = value.weeks.split(",");
        } else {
            weekArr = value.weeks;
        }
        $.each(weekArr, function(i, itemData) {
            if (itemData && typeof(itemData) == 'string') {
                let itemSpace = itemData.trim().replace(/\"/g, "");
                itemSpace = parseInt(itemSpace);
                weekDaysArr.push(itemSpace);
            }
        });
        if (weekDaysArr.length) {
            weekArr = weekDaysArr;
        } else {
            weekArr = weekArr;
        }
        return weekArr;
    },
    //封装按月的数据
    packageMonthDaysData(item) {
        let dayArr;
        let monthDayArr = new Array;
        let value = item.schedules;
        if (!(value.days instanceof Array)) {
            dayArr = value.days.split(",");
        } else {
            dayArr = value.days;
        }
        $.each(dayArr, function(i, itemData) {
            if (itemData && typeof(itemData) == 'string') {
                let itemSpace = itemData.trim().replace(/\"/g, "");
                itemSpace = parseInt(itemSpace);
                monthDayArr.push(itemSpace);
            }
        });
        if (monthDayArr.length) {
            dayArr = monthDayArr;
        } else {
            dayArr = dayArr;
        }
        return dayArr;
    },
    //处理任务按钮文本(废弃)
    showButtonTxt(direction,item) {
        var buttonTxt = "";
        if (item.branchType == 'realtime') {
            if (item.status != 'Stop' && item.status != 'InitStop' && item.status != 'TimeoutStop' && item.result != 'Cancel') {
                buttonTxt = direction.$t('language.cloudSync.pause');
                return buttonTxt;
            }
            buttonTxt = direction.$t('language.cloudSync.syncNow');
            return buttonTxt;
        }
        //如果任务未结束显示Cancel按钮
        if (this.showCancelButton(item)) {
            if (item.cancelingShow) {
                buttonTxt = null;
                return buttonTxt; //说明任务在取消状态中，不返回文案
            }
            buttonTxt = direction.$t('language.common.cancel');
            return buttonTxt;
        }
        //如果任务是错误或者部分成功，或者取消显示reTransfer重传按钮
        if (this.showRetransferButton(direction,item)) {
            if (item.type == 1) {
                buttonTxt = direction.$t('language.taskList.reTransfer');
                return buttonTxt;
            }
            if (item.type == 2) {
                buttonTxt = direction.$t('language.taskList.reSync');
                return buttonTxt;
            }
            if (item.type == 6) {
                if(item.tranferWay == 'backup' || item.tranferWay == 'retry-backup'){
                    buttonTxt = direction.$t('language.taskList.rebackup');
                    return buttonTxt;
                }
                buttonTxt =  direction.$t('language.cloudBackup.backupNow');
            }
            return buttonTxt;
        }
        //剩余情况显示Transfer Now 和 sync Now
        if (item.type == 1) {
            buttonTxt = direction.$t('language.cloudTransfer.transferNow');
            return buttonTxt;
        }
        if (item.type == 2) {
            buttonTxt = direction.$t('language.cloudSync.syncNow');
            return buttonTxt;
        }
        if (item.type == 6) {
            if ((taskListUtils.showFailStatus(item) || (taskListUtils.showpartialStatus(item) && !(item.tranferWay == 'restore' || item.tranferWay == 'retry-restore')))) {
                buttonTxt = direction.$t('language.taskList.rebackup');
                return buttonTxt;
            }
            buttonTxt = direction.$t('language.cloudBackup.backupNow');
            return buttonTxt;
        }
    },
    //(废弃)
    showCancelButton(item) { //表示该任务未结束
        let flag;
        //判断单个任务未结束
        if (!taskListUtils.judgeTaskEnd(item) && !item.sources) {
            flag = true;
            return flag;
        }
        if (item.branchType == 'businessTransfer' && (item.status == 'Running' || item.status == 'Waiting')) {
            return true;
        }
        //如果是多源或者多目标任务
        if (item.sources && item.branchType != 'businessTransfer') {
            $.each(item.sources, function(sIndex, sItem) {
                //如果任务状态在运行或者等待中
                if ((sItem.status == 'Running' || sItem.status == 'Waiting' || (sItem.syncDetail && sItem.syncDetail.runningStatus == 0))) {
                    flag = true;
                }
            });
        }
        return flag;
    },
    //显示重传按钮(废弃)
    showRetransferButton(direction,item) {
        let that = direction;
        let flag;
        //判断单个任务未结束，直接返回错误
        if (!taskListUtils.judgeTaskEnd(item) && !item.sources) {
            return false;
        }
        //如果单个任务存在错误任务，且结果为取消cancel或者错误error
        if (!item.sources && (that.unfinishedArr.includes(item.result) || item.errorFileCount || item.status == 'Canceled')) {
            flag = true;
        }
        if (item.sources && item.branchType != 'businessTransfer') {
            if (taskListUtils.judgeTaskEnd(item) && (that.unfinishedArr.includes(item.result) || item.errorFileCount || item.status == 'Canceled')) {
                flag = true;
            }
            //遍历多源多目标子任务，如果结果未结束并是错误或者取消，则显示重传按钮
            $.each(item.sources, function(sIndex, sItem) {
            if (taskListUtils.judgeTaskEnd(sItem) && (that.unfinishedArr.includes(sItem.result) || sItem.errorFileCount || sItem.status == 'Canceled')) {
                flag = true;
            }
            });
        }
        if (item.branchType == 'businessTransfer') {
            if (that.unfinishedArr.includes(item.result) || item.errorFileCount || item.status == 'Canceled') {
                flag = true;
            }
        }
        return flag;
    },
    //处理任务状态文本(废弃)
    showTaskStatus(direction,item) {
        var statusTxt = null;
        if (item.branchType == 'realtime') {
            if (item.status == 'Stop' || item.status == 'InitStop' || item.status == 'TimeoutStop' || item.result == 'Cancel') {
                statusTxt = direction.$t('language.cloudSync.paused');
                return statusTxt;
            }
            if (item.status == 'Init') {
                statusTxt = direction.$t('language.common.countFiles') + '...';
                //即时同步计数状态
                if (this.showRealTimeCountStatus(item)) {
                    if (!item.sources) {
                        statusTxt = direction.$t('language.common.countFiles') + '...(' + item.readyFindFileCount + direction.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.totalBytes) + ')';
                    } else {
                        this.clountRealTimeFiles();
                        statusTxt = direction.$t('language.common.countFiles') + '...(' + item.allreadyFindFileCount + direction.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.alltotalBytes) + ')';
                    }
                }
                return statusTxt;
            }
            statusTxt = direction.$t('language.cloudSync.realSyncing');
            return statusTxt;
        }
        //显示任务的取消状态
        if (taskListUtils.showCancelStatus(item) || item.cancelStatus) {
            statusTxt = direction.$t('language.common.canceled');
            return statusTxt;
        }
        //显示任务的运行状态 waiting counting running状态
        //running状态 1.单个或多个传输任务的运行状态
        if (taskListUtils.showTransferRunning(item)) {
            statusTxt = item.percent + '%...' + item.speed;
            return statusTxt;
        }
        //如果是备份任务运行中
        if (taskListUtils.showBackupRunning(item)) {
            if (!item.percent) {
                item.percent = 0;
            }
            if (item.tranferWay != 'restore' && item.tranferWay != 'retry-restore') {
                if (item.transferDetail && item.transferDetail.runningStatus == 3) {
                    statusTxt = direction.$t('language.cloudBackup.backingUp') + '...' + item.percent + '%' + direction.$t('language.cloudBackup.configFile');
                    return statusTxt;
                }
                if (item.transferDetail) {
                    statusTxt = direction.$t('language.cloudBackup.backingUp') + '...' + item.percent + '%';
                } else if (item.percent == 0) {
                    statusTxt = direction.$t('language.common.loadingData');
                }
            } else {
                if (item.transferDetail && item.transferDetail.runningStatus == 3) {
                    statusTxt = direction.$t('language.cloudBackup.restoring') + '...' + item.percent + '%' + direction.$t('language.cloudBackup.configFile');
                    return statusTxt;
                }
                if (item.transferDetail) {
                    statusTxt = direction.$t('language.cloudBackup.restoring') + '...' + item.percent + '%';
                } else if (item.percent == 0) {
                    statusTxt = direction.$t('language.common.loadingData');
                }
            }
            return statusTxt;
        }
        //单目标同步运行中状态
        if (taskListUtils.showSyncSingleRunning(item)) {
            if (direction.$i18n.locale != 'deutsch') {
                statusTxt = direction.$t('language.common.syncing') + '...' + item.percent + '%';
            } else {
                statusTxt = item.percent + '%' + direction.$t('language.common.syncing') + '...';
            }
            return statusTxt;
        }
        //多目标同步运行中状态
        if (taskListUtils.showSyncSourceRunning(item)) {
            if (item.avgpercent) {
                if (direction.$i18n.locale != 'deutsch') {
                    statusTxt = direction.$t('language.common.syncing') + '...' + item.avgpercent + '%';
                    return statusTxt;
                }
                statusTxt = item.avgpercent + '%' + direction.$t('language.common.syncing') + '...';
                return statusTxt;
            }
            statusTxt = direction.$t('language.common.syncing') + '...';
            return statusTxt;
        }
        //企业云盘传输的Counting状态
        if (this.showBusinessCountingStatus(item)) {
            var allCountFiles = 0;
            var allTotalBytes = 0;
            for (var i = 0; i < item.sources.length; i++) {
                if (item.sources[i].syncDetail && item.sources[i].syncDetail.state2.status == 1) {
                    allCountFiles += item.sources[i].syncDetail.state2.readyFindFileCount;
                    allTotalBytes += item.sources[i].syncDetail.state2.totalBytes;
                }
            }
            statusTxt = direction.$t('language.common.countFiles') + '...(' + allCountFiles + direction.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(allTotalBytes) + ')';
            return statusTxt;
        }
        //2.计数状态
        if (this.showCountingStatus(item)) {
            if (item.type == 1) {
                statusTxt = direction.$t('language.common.countFiles') + '...(' + item.transferDetail.state2.readyFindFileCount + direction.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.transferDetail.state2.totalBytes) + ')';
                return statusTxt;
            }
            if (item.type == 2) {
                if (!item.sources) {
                    statusTxt = direction.$t('language.common.countFiles') + '...(' + item.syncDetail.readyFindFileCount + direction.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.syncDetail.totalBytes) + ')';
                    return statusTxt;
                }
                statusTxt = direction.$t('language.common.countFiles') + '...(' + item.allreadyFindFileCount + direction.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.alltotalBytes) + ')';
                return statusTxt;
            }
            if (item.type == 6) {
                statusTxt = direction.$t('language.common.countFiles') + '...(' + item.transferDetail.readyFindFileCount + direction.$t('language.common.transferFiles') + ',' + commonUtils.formatByte(item.transferDetail.totalBytes) + ')';
                return statusTxt;
            }
        }
        //3.显示任务准备状态
        if (taskListUtils.showSyncSingleWaiting(item) || taskListUtils.showTransferWaiting(item) || taskListUtils.showSyncSourceWaiting(item) || taskListUtils.showBackupWaiting(item)) {
            statusTxt = direction.$t('language.common.waiting') + '...';
            return statusTxt;
        }
        //显示失败，部分成功状态的任务
        //单源失败，单源部分成功 多源失败，多源部分成功
        if (!item.sources) {
            if (taskListUtils.showFailStatus(item)) {
                if (item.type == 6) {
                    if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
                        statusTxt = direction.$t('language.cloudBackup.restoreFailure');
                        return statusTxt;
                    }
                    statusTxt = direction.$t('language.cloudBackup.backFailure');
                    return statusTxt;
                }
                if (item.type == 1 && item.transferDetail) {
                    delete item.transferDetail;
                }
                statusTxt = direction.$t('language.common.failure');
                return statusTxt;
            }
            if (taskListUtils.showpartialStatus(item)) {
                if (item.type == 6) {
                    if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
                        statusTxt = direction.$t('language.cloudBackup.restorePartial');
                    }else{
                        statusTxt = direction.$t('language.cloudBackup.backupPartial');
                    }
                    return statusTxt;
                }
                statusTxt = direction.$t('language.common.patial');
                return statusTxt;
            }
            if (taskListUtils.showSuccessStatus(item)) {
                if (item.type == 6) {
                    if (item.tranferWay != 'restore' && item.tranferWay != 'retry-restore') {
                        statusTxt = direction.$t('language.cloudBackup.backSuccess');
                    } else {
                        statusTxt = direction.$t('language.cloudBackup.restoreSuccess');
                    }
                    return statusTxt;
                }
                statusTxt = direction.$t('language.common.success');
                return statusTxt;
            }
        } else {
            if (taskListUtils.showSourcesFailureStatus(item)) {
                if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
                    statusTxt = direction.$t('language.cloudBackup.restoreFailure');
                    return statusTxt;
                }
                statusTxt = direction.$t('language.common.failure');
                return statusTxt;
            }
            if (taskListUtils.showSourcepartialStatus(item)) {
                if (item.tranferWay == 'restore' || item.tranferWay == 'retry-restore') {
                    statusTxt = direction.$t('language.cloudBackup.restorePartial');
                    return statusTxt;
                }
                statusTxt = direction.$t('language.common.patial');
                return statusTxt;
            }
            //多源成功
            if (taskListUtils.showSourceSuccessStatus(item)) {
                this.iconName = 'task-success';
                statusTxt = direction.$t('language.common.success');
                return statusTxt;
            }
        }
        if (item.viewed && item.branchType != 'realtime' && item.status != 'Normal') {
            statusTxt = direction.$t('language.popup.taskListPopup.viewLogs');
            return statusTxt;
        }
    },
    //(废弃)
    showTaskIconName(item) {
        var iconName = null;
        //显示任务的取消状态
        if (taskListUtils.showCancelStatus(item) || item.cancelStatus) {
            iconName = 'task-cancel';
            return iconName;
        }
        //显示任务的运行状态 waiting counting running状态
        //running状态 1.单个或多个传输任务的运行状态
        if (taskListUtils.showTransferRunning(item)) {
            iconName = 'task-running';
            return iconName;
        }
        //3.显示任务准备状态
        if (taskListUtils.showSyncSingleWaiting(item) || taskListUtils.showTransferWaiting(item) || taskListUtils.showSyncSourceWaiting(item) || taskListUtils.showBackupWaiting(item)) {
            iconName = 'task-waiting';
            return iconName;
        }
        //显示失败，部分成功状态的任务
        //单源失败，单源部分成功 多源失败，多源部分成功
        if (!item.sources) {
            if (taskListUtils.showFailStatus(item)) {
                iconName = 'task-failure';
            }
            if (taskListUtils.showpartialStatus(item)) {
                iconName = 'task-patial';
            }
            if (taskListUtils.showSuccessStatus(item)) {
                iconName = 'task-success';
            }
            return iconName;
        }else {
            if (taskListUtils.showSourcesFailureStatus(item)) {
                iconName = 'task-failure';
            }
            if (taskListUtils.showSourcepartialStatus(item)) {
                iconName = 'task-patial';
            }
            //多源成功
            if (taskListUtils.showSourceSuccessStatus(item)) {
                iconName = 'task-success';
            }
            return iconName;
        }
    },
    //显示企业云盘传输的counting状态(废弃)
    showBusinessCountingStatus(item) {
        if (item.type == 1 && item.branchType == 'businessTransfer' && item.status != 'Done') {
            for (var i = 0; i < item.sources.length; i++) {
                if (item.sources[i].syncDetail && (item.sources[i].syncDetail.state2.status == 'Done')) {
                    return false;
                } else {
                    if (item.sources[i].syncDetail && item.sources[i].syncDetail.state2.status == 1) {
                        return true;
                    }
                }
            }
        }
    },
    //(废弃)
    showCountingStatus(item) {
        if (item.type == 1) {
            if (item.transferDetail && item.transferDetail.state2 && item.transferDetail.state2.status == 1) {
                return true;
            }
        } else {
            if (!item.sources) {
                if (item.syncDetail && item.syncDetail.runningStatus == 1) {
                    return true;
                }
            }
            if (this.showSyncSourceCounting(item)) {
                return true;
            }
        }
        if (item.type == 6 && item.transferDetail && item.transferDetail.runningStatus == 1) return true;
    },
    //(废弃)
    showRealTimeCountStatus(item) {
        if (item.runningStatus <= 1) {
          return true;
        }
    },
    //显示多目标任务的计数状态(废弃)
    showSyncSourceCounting(item) {
        let that = this;
        let flag;
        let sourceArr = [];
        let resultArr = [];
        let resultFile = [];
        let resultByte = [];
        sourceArr.push(item);
        sourceArr.concat(item.sources);
        $.each(sourceArr, function(sIndex, sItem) {
            if ((item.syncDetail && item.syncDetail.runningStatus == 0)) {
                resultArr.push(1);
                resultByte.push(item.syncDetail.totalBytes);
                resultArr.push(item.syncDetail.readyFindFileCount);
            }
            if (sIndex == sourceArr.length - 1) {
                if (commonUtils.isAllEqual(resultArr) && resultArr[0] == 1) {
                    flag = true;
                    item.allreadyFindFileCount = that.sum(resultFile);
                    item.alltotalBytes = that.sum(resultByte);
                }
            }
        });
        return flag;
    },
    //(废弃)
    clountRealTimeFiles() {
        let that = this;
        let item = this.item;
        let sourceArr = [];
        sourceArr.push(item);
        sourceArr.concat(item.sources);
        let resultFile = [];
        let resultByte = [];
        $.each(sourceArr, function(sIndex, sItem) {
            if (item.runningStatus == 1) {
                resultByte.push(item.totalBytes);
                resultFile.push(item.readyFindFileCount);
            }
            if (sIndex == sourceArr.length - 1) {
                let allreadyFindFileCount = that.sum(resultFile);
                if (allreadyFindFileCount != 0) {
                    item.allreadyFindFileCount = allreadyFindFileCount;
                }
                let alltotalBytes = that.sum(resultByte);
                item.alltotalBytes = alltotalBytes;
            }
        });
    },
    sum(arr) { //求和
        var len = arr.length;
        if (len == 0) {
            return 0;
        } else if (len == 1) {
            return arr[0];
        } else {
            return arr[0] + sum(arr.slice(1));
        }
    },
}
export default task_method


// WEBPACK FOOTER //
// ./src/js/workspace/task_list_singel.js